import { createTheme, lighten } from '@mui/material/styles';
import { type Shadows } from '@mui/material/styles/shadows';

import { brand, grey, status, text } from '../colors';
import { generateShadow } from '../helpers';
import overrides from '../overrides';

/** Generate elevations */
const elevations = Array.from({ length: 25 }, (_, i) => generateShadow(i)) as Shadows;

const theme = createTheme({
  components: overrides,
  palette: {
    standard: {
      light: grey[400],
      main: grey[600],
      dark: grey[800],
      contrastText: text.primary,
    },
    primary: {
      main: brand.vfile.main,
      contrastText: '#fff',
    },
    secondary: {
      main: brand.vsuite.main,
      contrastText: brand.black.main,
      text: brand.vsuite.text,
      hover: brand.vsuite.hover,
    },
    error: {
      lighter: lighten(status.error, 0.9),
      main: status.error,
    },
    warning: {
      lighter: lighten(status.warning, 0.9),
      main: status.warning,
    },
    info: {
      lighter: lighten(status.info, 0.9),
      main: status.info,
    },
    success: {
      lighter: lighten(status.success, 0.9),
      main: status.success,
    },
    brand,
    grey,
    background: {
      default: grey[25],
    },
    text,
  },
  shadows: elevations,
  typography: {
    fontFamily: '"Source Sans Pro", Arial, sans-serif',
    fontSize: 13,
    fontWeightMedium: 600,
    h1: {
      fontSize: '1.8rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.6rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.4rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.2rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
    },
  },
  values: {
    maxContentWidth: 1120,
  },
  zIndex: {
    productColourBar: 1190,
  },
});

export { theme as default };
